/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TasksV2TypesEnum = 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VCF-AUTHORIZATION' | 'VMC-AUTHORIZATION' | 'RECONFIGURE' | 'DISCONNECTED-DEPLOYMENT' | 'VMC-POOL' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION';

export const TasksV2TypesEnum = {

    DEPLOYMENT: 'DEPLOYMENT' as TasksV2TypesEnum,

    SEED_OAUTH_APP: 'SEED-OAUTH-APP' as TasksV2TypesEnum,

    SUBSCRIPTION: 'SUBSCRIPTION' as TasksV2TypesEnum,

    RANSOMWARE_RECOVERY: 'RANSOMWARE-RECOVERY' as TasksV2TypesEnum,

    RELEASE: 'RELEASE' as TasksV2TypesEnum,

    MAINTENANCE: 'MAINTENANCE' as TasksV2TypesEnum,

    ACCESS: 'ACCESS' as TasksV2TypesEnum,

    MIGRATE: 'MIGRATE' as TasksV2TypesEnum,

    RELEASE_CAPABILITY: 'RELEASE-CAPABILITY' as TasksV2TypesEnum,

    BILLING_PIPELINE_REFRESH: 'BILLING-PIPELINE-REFRESH' as TasksV2TypesEnum,

    DATASTORE: 'DATASTORE' as TasksV2TypesEnum,

    CLOUD_PAIRING: 'CLOUD-PAIRING' as TasksV2TypesEnum,

    VCF_AUTHORIZATION: 'VCF-AUTHORIZATION' as TasksV2TypesEnum,

    VMC_AUTHORIZATION: 'VMC-AUTHORIZATION' as TasksV2TypesEnum,

    RECONFIGURE: 'RECONFIGURE' as TasksV2TypesEnum,

    DISCONNECTED_DEPLOYMENT: 'DISCONNECTED-DEPLOYMENT' as TasksV2TypesEnum,

    VMC_POOL: 'VMC-POOL' as TasksV2TypesEnum,

    RESOURCE_POOL: 'RESOURCE-POOL' as TasksV2TypesEnum,

    OAUTH_APP_SECRET_ROTATION: 'OAUTH_APP_SECRET_ROTATION' as TasksV2TypesEnum
};

